import {getDomainList} from '@/libs/api/api';

export default {
    components: {
    },
    props: {
        details: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            optionsDomain: [],
            valueDomain: '',
        }
    },
    mounted () {
        this.getDomainList()
    },
    methods: {
        async getDomainList () {
            let body = {
                organisation: this.details._id
            }
            // api call
            let response = await getDomainList(body);
            this.optionsDomain = response.domain.filter((item) => item.verified === true && item.is_short_url_registered == false)
        },
        addDomain () {
            let payload = {
                organisation_id: this.details._id,
                domain_id: this.valueDomain
            }
            this.$emit('add-domain', payload);
        }
    }
}